<template>
  <div class="pintuan-container">
    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/pintuan/pintuan_bg.jpg" class="pintuan-bg" />
    <div class="form-box">
      <div class="form-item">
        <input type="text" maxlength="15" placeholder="请输入名字" v-model="formData.name" />
      </div>
      <div class="form-item">
        <input type="text" maxlength="15" placeholder="请输入手机号" v-model="formData.mobile" />
      </div>
      <div class="form-item">
        <input type="text" maxlength="10" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <div class="submit" @click="onsubmit"></div>
    </div>
    <div class="success-alert" v-if="isShowAlert">
      <img
        src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/pintuan/success_alert.png"
        @click="isShowAlert = false"
        class="success-img"
      />
    </div>
  </div>
</template>

<script>
import { groupBuy, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      codeTime: 60,
      formData: {
        name: '',
        mobile: '',
        msg: ''
      },
      isShowAlert: false,
      //发送验证码
      isCodeClickable: true
    }
  },
  methods: {
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.formData.name) {
        return this.$toast.center('请输入名字')
      }
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      const gt = new Date().getTime().toString()
      groupBuy({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData
      }).then(res => {
        this.isShowAlert = true
        this.formData.name = ''
        this.formData.mobile = ''
        this.formData.msg = ''
      })
    }
  }
}
</script>
<style>
body {
  min-width: 100%;
  background: rgb(253, 64, 7);
}
</style>
<style lang="scss" scoped>
.pintuan-container {
  position: relative;
  .pintuan-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 177.8vw;
  }
  .form-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 73.5vw;
    .form-item {
      display: flex;
      align-items: center;
      width: 79vw;
      margin-bottom: 2.5vw;
      input {
        border: none;
        outline: none;
        flex: 1;
        height: 12vw;
        padding-left: 3vw;
        border-radius: 1.2vw;
        font-size: 3.8vw;
        color: rgb(158, 85, 58);
        background: rgb(243, 230, 209);
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 30vw;
        height: 12vw;
        margin-left: 1.2vw;
        border-radius: 1.2vw;
        font-size: 3.8vw;
        border: 1px solid rgb(255, 107, 64);
        color: rgb(255, 107, 64);
        box-sizing: border-box;
      }
    }
    .submit {
      width: 80vw;
      height: 15.5vw;
      margin-top: 3.5vw;
      cursor: pointer;
    }
  }
  .success-alert {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.6);
    .success-img {
      width: 78%;
    }
  }
}
</style>
